import React from 'react';
import Header from './components/Header';
import InputSearch from './components/InputSearch/InputSearch';
import './App.css';
import Home from './components/Home';
const App = () => {
  return (
    <div>
      <Header />
      <Home />
    </div>
  );
};

export default App;
